<template>
  <div class="my-vip-page">
    <!-- <h1>{{$t('grzl.t8')}}</h1> -->
    <h1 class="myvip-subtitle">{{$t('SidebarMenu.Menu98')}}</h1>
    <div class="my-vip-page-main">
      <div class="mybrandbox">
        <el-row :gutter=30>
          <el-col :span="8" v-for="brand in brandArr" :key="brand.id" >
            <div class="mybrandboxcol">
              <ul>
                <li><span>{{ $t('new.t17') }}</span><span>{{ brand.name }}</span></li>
                <li><span>{{ $t('new.t18') }}</span><span>{{ brand.levelname }}</span></li>
                <li><span>{{ $t('new.t19') }}</span><span>{{ brand.expire }}</span></li>
                <!-- <li><span>剩余投诉条数</span><span>{{ brand.balance }}</span></li> -->
              </ul>
              <!-- <button type="button" @click="onClickUpdata(brand.id)">升级</button> -->
            </div>
          </el-col>
        </el-row>
      </div>

    </div>

    <el-dialog 
      class="signup-page-dialog" 
      :visible.sync="showdialog" 
      center 
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :modal-append-to-body="true"
      :append-to-body="true"
    >
      <span class="modal-email-icon"></span>
      <h3>是否确定升级会员？</h3>
      <p>确定升级后，我们的客服将在第一时间联系您为您升级</p>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="updateVip(upid)" class="btn-bluelight">确 定</el-button>
        <el-button @click="showdialog = false">取 消</el-button>
      </span>
    </el-dialog>

    <el-dialog 
      class="signup-page-dialog" 
      :visible.sync="showdialog1" 
      center 
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :modal-append-to-body="true"
      :append-to-body="true"
    >
      <span class="modal-email-icon"></span>
      <h3>contact@simplybrand.com</h3>
      <p>您可以发送邮件给我们，我们会第一时间为您处理。</p>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="showdialog1 = false" class="btn-bluelight">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
export default {
  data() {
    return{
      isvipuser: JSON.parse(window.localStorage.getItem('status')).val > 0 ? true : false,
      userstatus: '',
      showdialog: false,
      showdialog1: false,
      myblance: '',
      myblancecost: '',
      vipexpire: '',
      viplevel: JSON.parse(window.localStorage.getItem('status')).val,
      brandArr: [],
      upid: ''
    }
  },

  mounted(){
    // if(this.isvipuser){
    //   this.requestUserBalance()
    // }
    // if(JSON.parse(window.localStorage.getItem('status')).val>0){
    //   //this.vipexpire = this.$moment(JSON.parse(window.localStorage.getItem('expire')).val).utc().format('YYYY-MM-DD')
    // }

    this.getuserPackage()

  },

  methods:{

    onClickUpdata: function(id){
      this.upid = 0
      this.showdialog = true
      this.upid = id
    },

    requestUserBalance: function(){
      let that = this
      let url = that.API_URL + '/v3/users/quota';
      $.ajax({
        url: url,
        type: "GET",
        changeOrigin: true,
        dataType: "json",
        contentType: "application/json",
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token")).val + ""
        },
        //data: JSON.stringify(submitFeedbackData),
        success: function(rex) {
          console.log('requestUserBalance', rex)
          that.myblancecost = rex.cost
          that.myblance = rex.balance
        },
        error: function(response) {
          console.log('requestUserBalance', response)
        }
      });
    },

    updateVip: function(id){
      let that = this
      let url = that.API_URL + '/v3/package/upgrade'
      let data = {
        id: id
      }
      $.ajax({
        url: url,
        type: "GET",
        changeOrigin: true,
        dataType: "json",
        contentType: "application/json",
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token")).val + ""
        },
        success: function(rex) {
          console.log('requestUserBalance', rex)
          that.showdialog = false
        },
        error: function(response) {
          console.log('requestUserBalance', response)
        }
      })
    },

    getuserPackage: function(){
      let that = this
      let url = that.API_URL + '/v3/package/list'
      $.ajax({
        url: url,
        type: "GET",
        changeOrigin: true,
        dataType: "json",
        contentType: "application/json",
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token")).val + ""
        },
        success: function(rex) {
          console.log('getuserPackage', rex)
          let arr = rex.package
          arr.forEach(item => {
            item.expire = that.$moment(item.expire).format('YYYY-MM-DD')
          })
          that.brandArr = arr
        },
        error: function(response) {
          console.log('getuserPackage', response)
        }
      })      
    }

  },

}
</script>

<style>
.my-vip-page h1{
  font-size: 24px;
  font-weight: normal;
  line-height: 39px;
  border-bottom: 1px solid #ddd;
  background-image: url(../../assets/img/Personal/icon_myvip.svg);
  background-repeat: no-repeat;
  background-position: left center;
  padding-left: 40px;
}
.my-vip-page-main{
  margin-top: 30px;
}
.box-card{
  width: 450px;
  height: 350px;
}
.box-card .el-card__header{
  border-bottom: none;
  height: 120px;
	padding: 0;
	font-size: 24px;
	color: #333;
	height: 120px;
	background-image: url(../../assets/img/dianshangfangxian_dialog_bg.png);
	background-position: center center;
	background-repeat: no-repeat;
	background-size: 100% 100%;
}
.box-card .el-card__header h2{
  text-align: center;
  line-height: 120px;
	font-size: 24px;
}
.box-card .el-card__body p{
  line-height: 24px;
}
.btn-contactus{
	width: 100%;
	height: 40px;
	border: none;
	background-color: #CD454A;
	color: #fff;
	cursor: pointer;
	border-radius: 2px;
}
.modal-email-icon{
	width: 80px;
	height: 80px;
	display: inline-block;
	background: url(../../assets/img/Personal/icon_email.svg) center no-repeat;
	background-size: cover;
	margin-bottom: 23px;
}
.isvipuser:before,
.isvipuser:after{
  content: '';
  display: table;
}
.isvipuser:after{
  clear: both;
}
.isvipuser-card{
  margin-right: 30px;
  width: 315px;
  height: 100px;
  float: left;
  background: #FFFFFF;
  box-shadow: 0 5px 24px 0 #E7E9EE;
  background-position: left center;
  background-repeat: no-repeat;
  background-size: auto 100px;
  padding-left: 120px;
  padding-right: 20px;
  padding-top: 20px;
  padding-bottom: 20px;
}
.isvipuser-card-used{
  background-image: url(../../assets/img/Personal/icon_used.svg);
}
.isvipuser-card-not-used{
  background-image: url(../../assets/img/Personal/icon_not_used.svg);
}
.isvipuser-card h3{
  color: #666;
  font-size: 14px;
  font-weight: normal;
}
.isvipuser-card h4{
  font-size: 24px;
  font-weight: normal;
}
.isvipuser-card-not-used h4{
  color: #CD454A;
}
.isvipuser-card h3,
.isvipuser-card h4{
  line-height: 30px;
}
.isvipuser-card-not-used h4 button{
  border: 1px solid #CD454A;
  border-radius: 4px;
  float: right;
  color: #CD454A;
  background-color: #fff;
  height: 24px;
  font-size: 14px;
  margin-top: 3px;
  padding: 0 5px;
  cursor: pointer;
}
.viptopinfo p{
  display: block;
  height: 50px;
  margin: 0;
  line-height: 50px;
}
.viptopinfo p > span{
  font-weight: bold;
  width: 130px;
  display: block;
  height: 50px;
  line-height: 50px;
  float: left;
}
.isvipuser-card-box{
  margin-top: 0px;
}
.viptopinfo p em{
  font-style: normal;
  display: block;
  height: 50px;
  padding-top: 10px;
  padding-bottom: 10px;
  float: left;
}
.viptopinfo p em i.viptext{
  height: 30px;
  display: block;
  line-height: 30px;
  float: left;
  font-style: normal;
  color: #000;
  font-weight: bold;
}
.viptopinfo p em .username-vipicon{
  display: block;
  float: left;
}
.viptopinfo p button{
  height: 30px;
  border: 1px solid #CD454A;
  border-radius: 4px;
  background-color: #fff;
  color: #CD454A;
  cursor: pointer;
  float: left;
  margin-top: 10px;
  margin-left: 10px;
}.viptopinfo p a{
  margin-left: 10px;
}
/* .myvip-subtitle{
  margin-top: 30px;
} */

.mybrandbox{
  margin-top: 30px;
  width: 100%;
}
.mybrandbox .mybrandboxcol{
  background: #FFFFFF;
  box-shadow: 0 5px 24px 0 #E7E9EE;
  border-radius: 2px;
  border-radius: 2px;
  padding: 15px;
  margin-top: 30px;
  padding-top: 15px;
  height: auto;
  overflow-y: hidden;
}
.mybrandbox ul{
  list-style: none;
  padding: 0;
  margin: 0;
  line-height: 30px;
}
.mybrandbox ul li{
  width: 100%;
}
.mybrandbox ul li span{
  width: 50%;
  height: 30px;
  display: block;
  float: left;
}
.mybrandbox button{
  width: 100%;
  border: 0;
  padding: 0;
  margin: 0;
  background-color: #fff;
  border: 1px solid #CD454A;
  color: #CD454A;
  font-size: 12px;
  height: 30px;
  border-radius: 4px;
  margin-top: 15px;
  cursor: pointer;
}
</style>
